import ProjectionAssignation from "./ProjectionAssignation";

export default class ProjectionPeople {
  firstName: string = "";
  lastName: string = "";
  userExternalId: string = "";
  email: string = "";
  assignations: ProjectionAssignation[] = [];
  availableHours: number = 0;

  constructor(
    firstName: string,
    lastName: string,
    userExternalId: string,
    email: string,
    assignations: ProjectionAssignation[],
    availableHours: number,
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.userExternalId = userExternalId;
    this.email = email;
    this.assignations = assignations;
    this.availableHours = availableHours;
  }

  freeHours() {
    let hours = 8;
    this.assignations.forEach((assig) => {
      hours = assig.shadow ? hours : hours - assig.externalHours + assig.bonusHours;
    });
    if (hours >= 8) {
      return 8;
    }

    if (hours <= 0) {
      return 0;
    }

    return hours;
  }

  assignedHours() {
    let hours = 0;
    this.assignations.forEach((assig) => {
      hours = hours + assig.externalHours;
    });
    return hours;
  }

  getProjectNames(): string {
    let names = "";
    this.assignations.forEach((assig) => {
      const projectName = assig.projectName;
      names = !(names === "") ? names + "/" + projectName : names + projectName;
    });

    return names;
  }

  getRoles(): string {
    let names = "";
    this.assignations.forEach((assig) => {
      const projectRole = assig.roleType;
      names = !(names === "") ? names + "/" + projectRole : names + projectRole;
    });

    return names;
  }

  getProjectAndRolesFormatted(): string {
    const projects: string[] = this.getProjectNames().split("/");
    const roles: string[] = this.getRoles().split("/");

    let formattedResponse: string = "";

    for (let index = 0; index < projects.length; index++) {
      let projectInfo: string = !(formattedResponse === "")
        ? ` / ${projects[index]}: ${roles[index]}`
        : `${projects[index]}: ${roles[index]}`;
      formattedResponse += projectInfo;
    }

    return formattedResponse;
  }

  public updateAssignationData(externalId: string, roleType?: string, hours?: number) {
    if (roleType) {
      this.assignations.find((a) => a.externalId === externalId)!.roleType = roleType;
    }

    if (hours) {
      this.assignations.find((a) => a.externalId === externalId)!.externalHours = hours;
    }

    this.availableHours = this.freeHours();
  }
}
